import Vue from 'vue';
import linkDynamic from '@editor/droplets/_bubble-options/components/link-dynamic';

export default Vue.component('edit-product-card', {
  template: require('./template.html'),
  name: 'edit-product-card',
  components: {
    linkDynamic,
  },
  props: ['droplet', 'show-edit-bubble', 'profile', 'product'],
  data() {
    return {
      display: {
        btnText: '',
      },
    };
  },
  watch: {
    showEditBubble(open) {
      if (open) {
        this.setInitialValues();
      }
    },
  },
  methods: {
    setInitialValues() {
      this.display.btnText = this.droplet.btnText;
    },
    getInputVal(val) {
      return val.trim() !== '' ? val : false;
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/product-card/components/_edit-options/index.js